
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.186 12.442l3.598-3.315a.48.48 0 000-.728l-3.598-3.315c-.197-.19-.47-.186-.637.005-.167.19-.138.463.053.644l3.282 3.027-3.282 3.033c-.191.18-.22.454-.053.644.168.19.44.19.637.005zm-8.375.005c.2.186.469.18.636-.01.168-.19.144-.459-.048-.64L1.117 8.766l3.282-3.032c.192-.18.216-.449.048-.644-.167-.19-.435-.19-.636-.005L.213 8.399a.487.487 0 000 .728l3.598 3.32zM5.423 11.004c.349 0 .64-.284.64-.64a.643.643 0 00-.64-.635.64.64 0 00-.64.636c0 .354.289.639.64.639zM7.972 11.004c.348 0 .64-.284.64-.64a.643.643 0 00-.64-.635.64.64 0 00-.64.636c0 .354.288.639.64.639zM10.52 11.004c.35 0 .64-.284.64-.64a.642.642 0 00-.64-.635.64.64 0 00-.638.636c0 .354.287.639.639.639z","fill":"#000C1F"}})])
          )
        }
      }
    